// plugins/bridge.js
import {
	l,
	lc,
	lm,
	lreplace
} from '@utils/toolbox.js';
export default {
	install: (app, options) => {
		app.config.globalProperties.$l = l;
		app.config.globalProperties.$lc = lc;
		app.config.globalProperties.$lm = lm;
		app.config.globalProperties.$lreplace = lreplace;
	}
};
